import { render } from "./card-popup-other-tag.vue?vue&type=template&id=0526201c&ts=true"
import script from "./card-popup-other-tag.vue?vue&type=script&lang=ts"
export * from "./card-popup-other-tag.vue?vue&type=script&lang=ts"

import "./card-popup-other-tag.vue?vue&type=style&index=0&id=0526201c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__